import { motion } from 'framer-motion'
import { PropsWithChildren } from 'react'

export const PricingStepWrapper = ({
  children,
  motionKey,
}: PropsWithChildren<{
  motionKey: string
}>) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -40 }}
      key={motionKey}
      transition={{
        duration: 0.95,
        ease: [0.165, 0.84, 0.44, 1],
      }}
      className="mx-auto px-2 lg:px-0 w-full flex items-center flex-col"
    >
      {children}
    </motion.div>
  )
}
